import { render } from "./profil.vue?vue&type=template&id=3351a832&scoped=true"
import script from "./profil.vue?vue&type=script&lang=js"
export * from "./profil.vue?vue&type=script&lang=js"

import "./profil.vue?vue&type=style&index=0&id=3351a832&scoped=true&lang=css"
import "./profil.vue?vue&type=style&index=1&id=3351a832&lang=css"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/hauptportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3351a832"]])

export default __exports__